import React from 'react';
import PropTypes from 'prop-types';

import Collection from '../../Collections/Collection';

const MARGIN_TOP_CLASS = 'mt-5';

const CollectionRenderer = ({ item, fieldsValidated, descriptionSetObject }) => {
  const divClassName =
    item.label && item.label.length > 100 ? 'col-lg-12' : 'col-lg-6';

  return (
    <Collection
      collectionName={item.collection}
      item={item}
      descriptionSet={
        descriptionSetObject !== undefined
          ? descriptionSetObject.description
          : []
      }
      className="col-lg-6"
      classNameMarginTop={MARGIN_TOP_CLASS}
      divClassName={divClassName}
      fieldsValidated={fieldsValidated}
    />
  );
};

CollectionRenderer.propTypes = {
  item: PropTypes.object.isRequired,
  fieldsValidated: PropTypes.bool,
  descriptionSetObject: PropTypes.object,
};

export default CollectionRenderer;
